export function scrollToTop() {
  if (typeof window !== "undefined" && window) {
    window.scrollTo(0, 0)
    document.getElementById("skip-nav").focus()
    document.getElementById("skip-nav").blur()
  }
}
